import { Button } from '@/shared/components';
import type { PreviewState } from './previewModel';

/** Fuß von „Wirkung prüfen“: Abbrechen und je Zustand genau eine nächste Aktion. */
export function PricingPreviewDialogFooter(props: {
  state: PreviewState;
  nextVersion: number;
  saving: boolean;
  /** Ein neuerer Stand auf dem Server – nur Neuladen hilft. */
  reloadable: boolean;
  retryable: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onRetry: () => void;
  onReload?: () => void;
}) {
  const { state, saving } = props;
  const reload = state === 'failed' && props.reloadable && props.onReload;
  const final = state === 'failed' && !reload && !props.retryable;
  return (
    <div className="flex flex-wrap justify-end gap-2.5">
      <Button
        variant="secondary"
        className="min-h-12 grow md:grow-0"
        disabled={saving}
        onClick={props.onClose}
      >
        {final ? 'Schließen' : 'Abbrechen'}
      </Button>
      {state === 'ready' ? (
        <Button
          variant="brand"
          className="min-h-12 grow md:grow-0"
          loading={saving}
          disabled={saving}
          onClick={props.onConfirm}
        >
          Version {props.nextVersion} aktivieren
        </Button>
      ) : reload ? (
        <Button variant="primary" className="min-h-12 grow md:grow-0" onClick={props.onReload}>
          Neuen Stand laden
        </Button>
      ) : final ? null : (
        <Button
          variant="primary"
          className="min-h-12 grow md:grow-0"
          disabled={state === 'loading' || saving}
          onClick={props.onRetry}
        >
          {state === 'loading' ? 'Bitte warten …' : 'Erneut versuchen'}
        </Button>
      )}
    </div>
  );
}
